import { importLibrary, setOptions } from '@googlemaps/js-api-loader'

let configured = false

export function configureGoogleMaps(apiKey: string): void {
  if (configured) return
  setOptions({ key: apiKey, v: 'weekly', language: 'en', region: 'SE' })
  configured = true
}

export { importLibrary }
